import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  Input,
  ViewChild,
} from '@angular/core';
import { DATA_TOKEN } from '../../../data.token';

type ChipType = 'primary' | 'accent' | 'alert' | 'info' | 'warning' | 'success';

@Component({
  selector: 'chip',
  imports: [],
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipComponent implements AfterViewInit {
  @Input() type: ChipType = 'primary';
  @ViewChild('chip') chipRef: ElementRef;

  private _injectedData = inject<{ type: ChipType; content: string }>(DATA_TOKEN, {
    optional: true,
  });

  constructor() {
    this.type = this._injectedData?.type || this.type;
  }

  ngAfterViewInit(): void {
    if (!this.chipRef.nativeElement.childNodes.length) {
      this.chipRef.nativeElement.innerText = this._injectedData.content;
    }
  }
}
